import { inject, Pipe, PipeTransform } from '@angular/core';
import { AnalysisApiService } from '../services';

@Pipe({
	standalone: true,
	name: 'analysisData',
})
export class AnalysisDataPipe implements PipeTransform {
	private readonly analysisApiService = inject(AnalysisApiService);

	/**
	 * Fetches the analysis object based on the id provided. If the analysis
	 * has been fetched previously, it will return the cache of the analysis
	 * instead to save on a call.
	 *
	 * @param id the id of the analysis to return
	 * @param useCache whether to use cached result if available
	 * @returns Promise resolving to the analysis or undefined
	 */
	transform(id: string, useCache = true) {
		return this.analysisApiService.findById(id, useCache);
	}
}
